webpackJsonp([20956934260092],{

/***/ 554:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/get-lamp-and-interactive-fiction/","categorySlug":"/categories/review/"},"frontmatter":{"title":"Get Lamp and Interactive Fiction","date":"2013-03-31T22:23:55.000Z","category":"Review","description":"Reviewing the interactive fiction documentary"}}}]}},"pathContext":{"tag":"programming"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-programming-f03310270ddce149dc91.js